import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Layout.css';
import tailwind from '../tailwind.css';
import Header from '../Header';
import Footer from '../Footer';
import CookiesDisclaimer from '../CookiesDisclaimer';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { viewListingBottom, becomeHeader, becomeHeaderCss } = this.props;
    return (
      <div className={viewListingBottom}>
        {/* SEO/A11y: Skip Link for keyboard navigation */}
        <a href="#main-content" className={s.skipLink}>
          Skip to main content
        </a>
        <Header becomeHeader={becomeHeader} becomeHeaderCss={becomeHeaderCss}/>
        <main role="main" id="main-content">
          {this.props.children}
        </main>
        <Footer />
        <CookiesDisclaimer />
      </div>
    );
  }
}

export default withStyles(s, tailwind)(Layout);